/* tap.it theme: small, dependency-free. Loaded with defer. */
(function () {
  'use strict';
  var d = document;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- mobile menu ---------- */
  var nav = $('[data-mobile-nav]');
  var navBtn = $('[data-menu-open]');
  function setNav(open) {
    if (!nav) return;
    nav.hidden = !open;
    if (navBtn) navBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    d.body.classList.toggle('has-drawer', open);
    var target = open ? $('[data-menu-close]', nav) : navBtn;
    if (target) target.focus();
  }

  /* ---------- cart drawer ---------- */
  var lastFocus = null;
  function drawer() { return $('[data-cart-drawer]'); }
  function openCart() {
    var el = drawer();
    if (!el) return false;
    lastFocus = d.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    d.body.classList.add('has-drawer');
    var panel = $('.cdrawer__panel', el);
    if (panel) panel.focus();
    return true;
  }
  function closeCart() {
    var el = drawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    d.body.classList.remove('has-drawer');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function applySections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = $('[data-cart-drawer]', doc);
    var cur = drawer();
    if (!fresh || !cur) return;
    var newPanel = $('.cdrawer__panel', fresh);
    var curPanel = $('.cdrawer__panel', cur);
    if (newPanel && curPanel) curPanel.innerHTML = newPanel.innerHTML;
    updateCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
  }
  function post(path, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) { throw json; }
        return json;
      });
    });
  }
  function add(items) {
    return post('cart/add.js', { items: items }).then(function (json) {
      applySections(json.sections);
      openCart();
      return json;
    });
  }
  function change(line, quantity) {
    return post('cart/change.js', { line: line, quantity: quantity }).then(function (json) {
      applySections(json.sections);
    });
  }
  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function flashError(btn, err) {
    var label = $('[data-add-label]', btn) || btn;
    var old = label.textContent;
    label.textContent = (err && (err.description || err.message)) || 'Could not add. Try again.';
    setTimeout(function () { label.textContent = old; }, 3500);
  }

  /* ---------- product page ---------- */
  function formItems(form) {
    var fd = new FormData(form);
    var props = {};
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.*)\]$/);
      if (m && v) props[m[1]] = v;
    });
    return [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity'), 10) || 1, properties: props }];
  }
  function addFromForm(form) {
    var btns = $$('[data-add-to-cart],[data-sticky-add]');
    btns.forEach(function (b) { busy(b, true); });
    return add(formItems(form))
      .catch(function (err) { flashError($('[data-add-to-cart]', form) || btns[0], err); })
      .then(function () { btns.forEach(function (b) { busy(b, false); }); });
  }

  function initProduct(sec) {
    var bq = +sec.dataset.bq, bundle = +sec.dataset.bundle, tq = +sec.dataset.tq, tier = +sec.dataset.tier;
    var cur = sec.dataset.currency || '$';
    var form = $('[data-product-form]', sec);
    var qtyInput = $('[data-qty-input]', sec);
    var totalEl = $('[data-total]', sec), unitEl = $('[data-unit]', sec);
    var stTotal = $('[data-sticky-total]', sec), stUnit = $('[data-sticky-unit]', sec);
    var addTotal = $('[data-add-total]', sec), addBtn = $('[data-add-to-cart]', sec);
    var select = $('[data-variant-select]', sec);
    var packs = $$('[data-pack]', sec);
    var singlePrice = $('[data-pack-price="single"]', sec);

    function money(c) { return cur + (c / 100).toFixed(2); }
    function base() {
      if (select && select.selectedOptions[0]) return +select.selectedOptions[0].dataset.price;
      return +sec.dataset.base;
    }
    function calc(q) {
      var b = base();
      if (q >= tq) return { total: q * tier, unit: q + ' x ' + money(tier) };
      if (q === bq) return { total: bundle, unit: bq + ' items, ' + money(Math.round(bundle / bq)) + ' each' };
      return { total: q * b, unit: q + ' x ' + money(b) };
    }
    function update() {
      var q = Math.max(1, Math.min(99, parseInt(qtyInput.value, 10) || 1));
      qtyInput.value = q;
      var r = calc(q);
      if (totalEl) totalEl.textContent = money(r.total);
      if (unitEl) unitEl.textContent = r.unit;
      if (stTotal) stTotal.textContent = money(r.total);
      if (stUnit) stUnit.textContent = r.unit;
      if (singlePrice) singlePrice.textContent = money(base()) + ' each';
      if (addTotal) addTotal.textContent = addBtn && !addBtn.disabled ? ', ' + money(r.total) : '';
      var want = q >= tq ? String(tq) : (q === bq ? String(bq) : '1');
      packs.forEach(function (p) { p.checked = p.value === want; });
    }
    packs.forEach(function (p) {
      p.addEventListener('change', function () { qtyInput.value = p.value; update(); });
    });
    $('[data-qty-minus]', sec).addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; update(); });
    $('[data-qty-plus]', sec).addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; update(); });
    qtyInput.addEventListener('change', update);
    if (select) select.addEventListener('change', update);
    update();

    /* sticky add-to-cart bar (mobile): visible while the main button is off screen */
    var bar = $('[data-sticky-bar]', sec);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
      }, { rootMargin: '0px 0px -80px 0px' });
      io.observe(addBtn);
    } else if (bar) {
      bar.hidden = false;
    }
    var stickyAdd = $('[data-sticky-add]', sec);
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addFromForm(form); });

    /* gallery */
    $$('[data-gallery-thumb]', sec).forEach(function (t) {
      t.addEventListener('click', function () {
        var img = $('#gallery-main-img', sec);
        if (!img) return;
        img.src = t.dataset.src;
        img.srcset = t.dataset.srcset;
        img.alt = t.dataset.alt;
        $$('[data-gallery-thumb]', sec).forEach(function (o) { o.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- global clicks ---------- */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var el;
    if ((el = t.closest('[data-menu-open]'))) { e.preventDefault(); setNav(true); return; }
    if ((el = t.closest('[data-menu-close]'))) { e.preventDefault(); setNav(false); return; }
    if (t.closest('[data-mobile-nav] a')) { setNav(false); return; }
    if ((el = t.closest('[data-cart-open]'))) { if (openCart()) e.preventDefault(); return; }
    if ((el = t.closest('[data-cart-close]'))) { e.preventDefault(); closeCart(); return; }
    if ((el = t.closest('[data-cart-change]'))) {
      e.preventDefault();
      change(parseInt(el.dataset.cartChange, 10), parseInt(el.dataset.qty, 10));
      return;
    }
    if ((el = t.closest('[data-quick-add]'))) {
      e.preventDefault();
      busy(el, true);
      add([{ id: parseInt(el.dataset.quickAdd, 10), quantity: 1 }])
        .catch(function () { window.location.href = el.getAttribute('href'); })
        .then(function () { busy(el, false); });
    }
  });

  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.matches && form.matches('[data-product-form]')) {
      e.preventDefault();
      addFromForm(form);
    }
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var el = drawer();
      if (el && el.classList.contains('is-open')) closeCart();
      else if (nav && !nav.hidden) setNav(false);
      return;
    }
    if (e.key === 'Tab') {
      var open = drawer();
      if (!open || !open.classList.contains('is-open')) return;
      var focusable = $$('a[href],button:not([disabled]),input,select,[tabindex="0"]', $('.cdrawer__panel', open)).filter(function (n) { return n.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
